import { ReactNode } from "react";
import classNames from "classnames";
import { useAdminSelector } from "../../../stores/AdminStore";

interface ContentProps {
  className?: string;
  children: ReactNode;
  variant?: "pos" | "default";
}

export const Content = ({children, className, variant = "default"}: ContentProps) => {
  const open = useAdminSelector(s => s.menu.open);

  return (
    <div
      className={classNames(className, variant !== "pos" ?"p-2 md:px-4 md:py-2" : "", "w-full h-full", open ? "hidden md:block" : "")}>
      {children}
    </div>
  );
};
